import { OnInit, Component } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from 'src/app/shared/services/alert.service';
import { GlobalService } from 'src/app/shared/global.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { UtilService } from 'src/app/shared/services/util.service';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import * as moment from 'moment';

@Component({
    selector: 'app-reporte-cantidades',
    templateUrl: './reporte-cantidades.component.html',
    styleUrls: ['./../reporte-UAC.component.scss']
})

export class ReporteCantidadesComponent implements OnInit {

    public filtroTramite: string;
    public filtroDocumento: string;
    public filtroSede: string;
    public filtroCertificado: string = null;
    public filtroFechaInicio: Date;
    public filtroFechaFin: Date;
    public filtroTramiteExcel: string;
    public filtroDocumentoExcel: string;
    public filtroFechaInicioExcel: Date;
    public filtroFechaFinExcel: Date;
    public filtroSedeExcel: string;
    public filtroCertificadoExcel: string;

    public tramites: string[];
    public validar = true;
    public validarExportar = true;
    public datosArchivo: any;
    public cantidades: string[];
    public sede: string;
    public placeholderDate: string;

    public paginas: number[];
    public inicio: number;
    public fin: number;
    public urlFtp: string;

    constructor(
        private global: GlobalService,
        private urlService: UrlService,
        private spinner: NgxSpinnerService,
        private alertService: AlertService,
        private utilService: UtilService
    ) { }

    ngOnInit() {
        this.placeholderDate = ConstantesService.SELECCION_FECHA;
        this.consultarParametroPorDefecto();
        this.obtenerTramite();
        this.urlFtp = sessionStorage.getItem(ConstantesService.FTP_SESSSION);
    }

    /**
     * Consulta los Trámites Existente
     */
    public obtenerTramite() {
        this.spinner.show();
        const serviceProvider = 'tramiteUAC';
        const pathParams: Array<[string, string]> = new Array<[string, string]>();
        pathParams.push(['filterBy=estado', ConstantesService.ESTADO_TRAMITE_ACTIVO]);
        let url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, pathParams, null), this.urlService.hostAPI_UAC);
        url = url + '&orderBy=nombre$ASC';
        this.global.getGenerico(url).subscribe(
            data => {
                this.tramites = data;
                this.spinner.hide();
            }, err => {
                this.cathException('No es posible Cargar los servicios');
            }
        );
    }

    /**
     * Consulta los tipo de Sedes Existente
     */
    public obtenerSede() {
        this.spinner.show();
        const serviceProvider = 'ObtenerDominio';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=detalleDominioPK.nombreDominio', 'Sede']);
        const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.sede = data;
                this.spinner.hide();
            }, err => {
                this.cathException('No es posible Obtener las Sedes');
            }
        );
    }

    /**
     * Método que recolecta los filtros y realiza el llamado del servicio correspondiente
     * al BACKEND y obtiene el resultado de la consulta deseada
     */
    public GenerarReporteCantidades() {
        if (this.filtroFechaInicio < this.filtroFechaFin || this.filtroFechaInicio.getTime() === this.filtroFechaFin.getTime()) {
            if (this.filtroFechaFin < new Date()) {
                this.GenerandoReporte();
            } else {
                this.alertService.generateAlertError('La fecha fin no puede ser superior a la fecha de sistema', '');
            }
        } else {
            this.alertService.generateAlertError('La fecha fin no puede ser inferior a la fecha inicio', '');
        }
    }

    /**
     * Método que recolecta los filtros y realiza el llamado del servicio correspondiente
     * al BACKEND y obtiene el resultado de la consulta deseada
     */
    public GenerandoReporte() {
        this.spinner.show();
        this.filtroTramiteExcel = this.filtroTramite; this.filtroDocumentoExcel = this.filtroDocumento;
        this.filtroFechaInicioExcel = this.filtroFechaInicio; this.filtroFechaFinExcel = this.filtroFechaFin;
        this.filtroSedeExcel = this.filtroSede; this.filtroCertificadoExcel = this.filtroCertificado;
        this.validacion();
        const filtros = {
            filtroTramite: this.filtroTramite,
            filtroDocumento: this.filtroDocumento,
            filtroSede: this.filtroSede,
            filtroCertificado: this.filtroCertificado,
            filtroFechaInicio: this.filtroFechaInicio,
            filtroFechaFin: this.filtroFechaFin
        };
        const serviceProvider = 'reporteCantiadesTabla';
        const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_UAC);
        this.global.postGenerico(url, filtros).subscribe(
            data => {
                if (data.length > 0) {
                    this.cantidades = data;
                    this.validarExportar = false;
                    this.paginador();
                } else {
                    this.cathException('Consulta sin datos');
                    this.cantidades = undefined;
                }
            }, err => {
                this.cathException('El reporte no se ha podido generar');
            }
        );
    }

    /**
     * Método que recolecta los filtros y realiza el llamado del servicio correspondiente
     * al BACKEND y obtiene el resultado de la consulta deseada
     */
    public GenerarReporteExportar() {
        this.spinner.show();
        this.validacion();
        const filtros = {
            filtroTramite: this.filtroTramiteExcel,
            filtroDocumento: this.filtroDocumentoExcel,
            filtroSede: this.filtroSedeExcel,
            filtroCertificado: this.filtroCertificadoExcel,
            filtroFechaInicio: this.filtroFechaInicioExcel,
            filtroFechaFin: this.filtroFechaFinExcel
        };
        const serviceProvider = 'reporteCantiades';
        const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_UAC);
        this.global.postGenerico(url, filtros).subscribe(
            data => {
                this.datosArchivo = data;
                this.alertService.generateAlertSuccess('Su reporte se está descargando', '');
                this.descargarArchivo();
            }, err => {
                this.cathException('El reporte no se ha podido exportar');

            }
        );
    }

    /**
     * Metodo encargado de colocar la foto de la persona o en dicha caso que no tenga
     * coloca la foto por defecto
     */

    public obtenerUrlFoto(url: string): string {
        if (this.urlFtp && this.urlFtp !== '' && url) {
            return this.urlFtp + url;
        }
    }

    /**
     * Metodo que valida los campos obligatorios para porder habilitar el boton Generar Reporte
     */
    public validacion() {
        if (this.utilService.validarCamposObligatorios(this.filtroFechaInicio) &&
        this.utilService.validarCamposObligatorios(this.filtroFechaFin) &&
        // this.utilService.validarCamposObligatorios(this.filtroCertificado) &&
        this.utilService.validarCamposObligatorios(this.filtroSede)) {
            this.validar = false;
        } else {
            this.validar = true;
        }
        if (this.filtroTramiteExcel !== this.filtroTramite ||
            this.filtroDocumentoExcel !== this.filtroDocumento ||
            this.filtroFechaInicioExcel !== this.filtroFechaInicio ||
            this.filtroFechaFinExcel !== this.filtroFechaFin ||
            this.filtroCertificadoExcel !== this.filtroCertificado) {
            this.validarExportar = true;
        }
        if (!this.utilService.validarCamposObligatorios(this.filtroTramite)) {
            this.filtroTramite = undefined;
        }
        if (this.filtroDocumento === '') {
            this.filtroDocumento = undefined;
        }
    }

    /**
     * Metodo que evalua el paginador par ubicar en bloques de 10 registros
     */
    public paginador() {
        this.paginas = [];
        this.inicio = 0;
        this.fin = 10;
        if (this.cantidades) {
            const paginaAdicional: boolean = (this.cantidades.length % 10) !== 0;
            let numeroPaginas = Math.round(this.cantidades.length / 10);
            numeroPaginas = paginaAdicional ? numeroPaginas + 1 : numeroPaginas;

            for (let i = 0; i < numeroPaginas; i++) {
                const element = numeroPaginas[i];
                this.paginas.push(element);
            }
        }
        this.spinner.hide();
    }

    /**
     * Metodo encargado de cambiar la pagina
     */
    public cambiarPagina(valor: any) {
        switch (valor) {
            case 'a':
                this.inicio = 0;
                this.fin = 10;
                break;

            case 's':
                const mod = this.cantidades.length % 10;

                if (mod === 0) {
                    this.inicio = this.cantidades.length - 10;
                } else {
                    this.inicio = this.cantidades.length - mod;
                }
                this.fin = this.cantidades.length;
                break;

            default:
                this.inicio = (valor - 1) * 10;
                this.fin = valor * 10;
                break;

        }
    }

    /**
     * Método que valida la fecha Inicial y la anexa a una variable especifica filtroFechaInicio
     */
    public handlerDatePickeRInicio(event) {
        this.filtroFechaInicio = moment(this.utilService.convertirFechaConcatenada(event), 'DD-MM-YYYY').toDate();
    }

    /**
     * Método que valida la fecha Final y la anexa a una variable especifica filtroFechaFin
     */
    public handlerDatePickeRFin(event) {
        this.filtroFechaFin = moment(this.utilService.convertirFechaConcatenada(event), 'DD-MM-YYYY').toDate();
    }

    /**
     * Método que convierte el archivo Excel y realiza la descarga del mismo
     */
    descargarArchivo() {
        ConstantesService.descargarDocumento('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            , this.datosArchivo.nombre, this.datosArchivo.archivo);
        this.spinner.hide();
    }

    /**
     * Método que consulta la sede por defecto
     */
    public consultarParametroPorDefecto() {
        this.spinner.show();
        const serviceProvider = 'consultarParametros';
        const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_TRANS);
        this.global.postGenerico(url, [DominiosService.SEDE_POR_DEFECTO]).subscribe(
            data => {
                if (data.length > 0) {
                    this.filtroSede = data[0].valor;
                    this.obtenerSede();
                } else {
                    this.alertService.generateAlertError('Ocurrio un error consultando el parametro por defecto de la sede', 'Error');
                    this.spinner.hide();
                }
            }, err => {
                this.alertService.generateAlertError('Ocurrio un error consultando el parametro por defecto de la sede', 'Error');
                this.spinner.hide();
            }
        );
    }

    /**
     * Método de control de Excepciones
     * @param error mensaje saliente respecto al error ocurrido
     */
    cathException(error) {
        this.alertService.generateAlertError(error, 'Error');
        this.spinner.hide();
    }
}
